var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransform1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4613_25753",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4613_25753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 35.6875C20.5208 36.8958 22 37.5 23.75 37.5C25.5 37.5 26.9792 36.8958 28.1875 35.6875L38.1875 25.6875C39.3958 24.4792 40 23 40 21.25C40 19.5 39.3958 18.0208 38.1875 16.8125C36.9792 15.6042 35.5 15 33.75 15C32 15 30.5208 15.6042 29.3125 16.8125C27.7708 16.2708 26.25 16.1458 24.75 16.4375C23.25 16.7292 21.9792 17.3958 20.9375 18.4375C19.8958 19.4792 19.2292 20.75 18.9375 22.25C18.6458 23.75 18.7708 25.2708 19.3125 26.8125C18.1042 28.0208 17.5 29.5 17.5 31.25C17.5 33 18.1042 34.4792 19.3125 35.6875ZM15 55V44.25C12.625 42.0833 10.7813 39.5521 9.46875 36.6562C8.15625 33.7604 7.5 30.7083 7.5 27.5C7.5 21.25 9.6875 15.9375 14.0625 11.5625C18.4375 7.1875 23.75 5 30 5C35.2083 5 39.8229 6.53125 43.8438 9.59375C47.8646 12.6562 50.4792 16.6458 51.6875 21.5625L54.9375 34.375C55.1458 35.1667 55 35.8854 54.5 36.5312C54 37.1771 53.3333 37.5 52.5 37.5H47.5V45C47.5 46.375 47.0104 47.5521 46.0312 48.5312C45.0521 49.5104 43.875 50 42.5 50H37.5V55H32.5V45H42.5V32.5H49.25L46.875 22.8125C45.9167 19.0208 43.875 15.9375 40.75 13.5625C37.625 11.1875 34.0417 10 30 10C25.1667 10 21.0417 11.6875 17.625 15.0625C14.2083 18.4375 12.5 22.5417 12.5 27.375C12.5 29.875 13.0104 32.25 14.0312 34.5C15.0521 36.75 16.5 38.75 18.375 40.5L20 42V55H15Z",
    fill: "#FF595E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransform1);
export default __webpack_public_path__ + "static/media/transform1.31657700983869967548a8ca61408af2.svg";
export { ForwardRef as ReactComponent };